import { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import FooterPage from "./FooterPage/FooterPage";

// Route components are code-split so each page only downloads the JS it needs,
// keeping the initial bundle small and improving load time / Core Web Vitals.
const Home = lazy(() => import("./Home/Home"));
const ContactUs = lazy(() => import("./ReachUs/ContactUs"));
const CareerPage = lazy(() => import("./ReachUs/CareerPage/CareerPage"));
const Insights = lazy(() => import("./BlogPage/Insights"));
const BlogView = lazy(() => import("./BlogPage/BlogView/BlogView"));
const WhoWeAre = lazy(() => import("./WhoWeAre/WhoWeAre"));
const Enrol = lazy(() => import("./WhatWeDo/Enrol"));
const ProductPage = lazy(() => import("./WhatWeDo/ProductPage"));
const TermsAndConditions = lazy(() =>
  import("./TermsAndConditions/TermsAndConditions")
);
const PrivacyPolicy = lazy(() => import("./PrivacyPolicy/PrivacyPolicy"));
const Forbidden = lazy(() => import("./ForbiddenPage/Forbidden"));

export default function App() {
  window.scrollTo(0, 0);
  return (
    <div>
      <BrowserRouter>
        <Suspense fallback={<div style={{ minHeight: "100vh" }} />}>
          <Routes>
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/careers" element={<CareerPage />} />
            <Route path="/blog" element={<Insights />} />
            <Route path="/blog/:id" element={<BlogView />} />
            <Route path="/whoWeAre" element={<WhoWeAre />} />
            <Route path="/whatWeDo/Enrol" element={<Enrol />} />
            <Route path="/whatWeDo/:id" element={<ProductPage />} />
            <Route path="/termsandconditions" element={<TermsAndConditions />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/" element={<Home />} />
            <Route path="*" element={<Forbidden />} />
          </Routes>
        </Suspense>
        <FooterPage />
      </BrowserRouter>
    </div>
  );
}
